// activation feature barrel — public surface visible to the shell.
//
// Per architecture §11.4 the activation gate stays embedded in the
// shell rather than parcel-extracted: it's an overlay other features
// trigger via `openActivationGate()` from the kernel bus. The shell
// composes <ActivationGateMount /> into App.vue; this barrel is the
// only path the shell may use to reach in.
import type { RouteRecordRaw } from 'vue-router';

import ActivationGateMountImpl from './components/ActivationGateMount.vue';

export const routes: RouteRecordRaw[] = [];
export const ActivationGateMount = ActivationGateMountImpl;
export { useActivationStore } from './store';
export type { Kernel } from './store';
